"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSetupDirectDebit = void 0;
var kapi_1 = require("../../../shared/api/kapi");
var legacy_queries_1 = require("../../../shared/api/legacy-queries");
var mapping_1 = require("../../profile/data/mapping");
var mapping_2 = require("./mapping");
var useSetupDirectDebit = function (accountId, customerId) {
    var directDebitLegacyQueryResult = (0, legacy_queries_1.useDirectDebitLegacyQuery)(accountId);
    var _a = (0, kapi_1.useProfileQuery)({
        variables: {
            customerId: customerId,
            accountId: accountId,
        },
    }), profileData = _a.data, profileLoading = _a.loading, profileError = _a.error;
    var loading = profileLoading || directDebitLegacyQueryResult.isFetching;
    var error = directDebitLegacyQueryResult.status === 'error' || profileError
        ? mapping_2.genericError
        : undefined;
    var data = {
        profile: (0, mapping_1.mapProfileQueryKapiToProfileCX)(profileData),
        directDebit: directDebitLegacyQueryResult.status === 'data'
            ? directDebitLegacyQueryResult.data
            : null,
    };
    return {
        loading: loading,
        error: error,
        data: data,
    };
};
exports.useSetupDirectDebit = useSetupDirectDebit;
